module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/logo-c71f9a35debbd9f40e797fdb0422aaa0.png";